import { createGlobalStyle } from 'styled-components'

const BazaarGlobalStyle = createGlobalStyle`
  .bazaarvoice-container {
    margin: 60px 0 0;
    @media (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
      margin: 0;
    }
    @media (min-width: ${(props) => props.theme.size.breakpoint['min-width'].lg}) {
      margin: 0 15px;
    }
  }
`

export default BazaarGlobalStyle
